import { render, staticRenderFns } from "./router-link.vue?vue&type=template&id=9fa35b84"
import script from "./router-link.vue?vue&type=script&lang=ts"
export * from "./router-link.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports